import moment from 'moment';
import _ from 'underscore';
import {uniqWith}  from "lodash"
import Constants from '../constants/constants';
import { formbScrubber } from '../util/formbScrubber';
import { formValidation } from '../util/formValidation';

var Schematic = require("../tmds/Schematic");
var TrackFields = Schematic.trackKeyFields();
var TYPES = Constants.RestrictionTypes;

/**
 * Converts a form b from client format (flat format) to server format (object format)
 * @param _form
 * @returns {{id: *, phoneNumber: *, status: *, version: *, supervisorName: *, rejectionReason: *, restrictionDetail: {id: *, workEndMp: *, workEndMpSuffix: (*|string), workStartMp: *, workStartMpSuffix: (*|string), subdivision: *, type: string, authInitials: (*|string), version: *, formBDetail: {foremanId: (*|string), foremanName: (*|string), gang: (*|string), impedesTraffic: (*|string), reason: (*|string|string), radioChannel: (*|string), timezone: (*|string), workEndDate: string, workEndDay: *, workStartDate: string, workStartDay: *, version: *}, shortFlag: {restrictionFlagsNotDisplayed: string, flagOneMp: *, flagOneMpSuffix: (*|string), flagTwoMp: *, flagTwoMpSuffix: (*|string), version: *}, tracks: Array, borderingFlags: (*|Array|flags), comments: *}}|*}
 */
function convertFormToServerFormat(_form) {
    //move the form details to a new object
    var form = _form;

    // let comments = [...(form.comments || [])];
    // const { keyTrainSpd, keyTrainComment } = window.gritConfig;
    // if (Number(form.freightSpeed) === Number(keyTrainSpd)) {
    //   comments.unshift({ comment: keyTrainComment });
    //   comments = comments.map((c, index) => ({ ...c, lineNumber: index + 1 }));
    //   form.comments = comments;
    // }

    //Check if the freight speed is set to the key train speed
    const { keyTrainSpd, keyTrainComment } = window.gritConfig;
    if (Number(form.freightSpeed) === Number(keyTrainSpd)) {
        //See if the key train comment already exists
        let hasKeyTrainComment = false
        for (let i = 0; i < form.comments.length; i++) {
            if (form.comments[i].comment === keyTrainComment) {
                hasKeyTrainComment = true;
                break;
            }
        }

        //If it does not exist, add it
        if (!hasKeyTrainComment) {
            form.comments.unshift({ comment: keyTrainComment });
            form.comments = form.comments.map((c, index) => ({ ...c, lineNumber: index + 1 }));
        }
    }
    else {
        // If the freight speed is different, make sure the keytrain comment is removed
        form.comments = form.comments.filter((item) => item.comment !== keyTrainComment)
    }

    var restriction = {
        //"id": form.requestId,
        "phoneNumber": form.phoneNumber,
        "status": form.status,
        "version": form.version,
        "gritVersion": form.gritVersion,
        "supervisorName": form.supervisorName,
        "rejectionReason": form.rejectionReason,
        "pendingAction": form.pendingAction,
        "dispatchers": uniqWith(form?.dispatchers || [], _.isEqual)
            .map(d => ({
                dispatcherId: d.dsid,
                statusCode: d.status,
            })),
        "syncId": form.syncId,
        "createUser": form.createUser,
        "createTimeStamp": form.createTimeStamp,
        "warningNumber": form.warningNumber,
        "restrictionDetail": {
            //"id": form.id,
            "workEndMp": form.workEndMp,
            "workEndMpSuffix": form.workEndMpSuffix,
            "workStartMp": form.workStartMp,
            "workStartMpSuffix": form.workStartMpSuffix,
            "subdivision": form.subdivision,
            "type": form.type,
            "authInitials": form.authInitials,
            "version": form.restrictionVersion,
            "tmTblDirection": form.timeTableDirection,
            "timezone": form.timezone,
            "controlNumber": form.controlNumber,
            "effectiveTimeStamp": form.effectiveTimeStamp,

            "shortFlag": {
                "restrictionFlagsNotDisplayed": "N",
                "flagOneMp": form.shortFlagOneMp,
                "flagOneMpSuffix": form.shortFlagOneMpSuffix,
                "flagTwoMp": form.shortFlagTwoMp,
                "flagTwoMpSuffix": form.shortFlagTwoMpSuffix,
                "version": form.shortFlagVersion,
            },
            "tracks": form.tracks.map(function (track, i) {
                if (track.checked) {
                    return { name: track.name, seq: i, version: track.trackVersion }
                }
            }),
            "borderingFlags": form.borderingFlags,
            "comments": form.comments,
            "trackGuids": _.union(convertGuidToServerFormat(_form.trackGuids, false), convertGuidToServerFormat(_form.excludedGuids, true)),
            //other fields...
        }
    };

    if (form.type === TYPES.A) {

        restriction.restrictionDetail.shortFlag.restrictionFlagsNotDisplayed = form.shortFlagsNotDisplayed ? "Y" : "N";
        // console.log("----------------------form.appliesToLimitedNumberOfTrains " + form.appliesToLimitedNumberOfTrains +
        //     "outForExtendedTime: " + form.outForExtendedTime);
        var forma = {
            //form a fields
            "formADetail": {
                "passengerSpeed": ((form.passengerSpeed + "").toUpperCase() === 'NA') ? -1 : form.passengerSpeed,
                "freightSpeed": ((form.freightSpeed + "").toUpperCase() === 'NA') ? -1 : form.freightSpeed,
                "reasonCodeId": form.reason,
                "effectiveTime": form.effectiveDate ? moment(form.effectiveDate + " " + form.effectiveTime, "MMDDYY HHmm").tz(Constants.Timezones[form.timezone], true).format("YYYY-MM-DDTHH:mm:ss.SS") : "",// moment().format('MMDDYY HHmm'),\'T\'HH:mm:ss.SSS' The true flag passed to tz keeps the time the same and just adds the timezone
                "effectiveTimezone": form.timezone,
                "expectedExpireTime": moment(form.expectedExpireDate + " 2359", "MMDDYYHHmm").tz(Constants.Timezones[form.timezone], true).format("YYYY-MM-DDTHH:mm:ss.SS"), //'T'HH:mm:ss.SSS
                "authorizedBy": form.authorizedBy,
                "sloDtChangeReason": form.sloDtComment,
                "version": form.formaVersion,
                "appliesToLimitedNumberOfTrains": form.appliesToLimitedNumberOfTrains,
                "outForExtendedTime": form.outForExtendedTime,
                "tmdsTagsPlaced": form.tmdsTagsPlaced
            }
        };

        $.extend(restriction.restrictionDetail, forma);
    }
    else if (form.type === TYPES.B) {
        var formb = {
            //form b fields
            "formBDetail": {
                "foremanId": form.foremanId,
                "foremanName": form.foremanName,
                "gang": form.gang,
                "impedesTraffic": form.impedesTraffic,
                "reasonCodeId": form.reason,
                "radioChannel": form.radioChannel,
                "timezone": form.timezone,
                "workEndDate": moment(form.workEndDate + " " + form.workEndTime, "MMDDYY HHmm").format("YYYY-MM-DDTHH:mm:ss.SS"),
                "workEndDay": form.workEndDay,
                "workStartDate": moment(form.workStartDate + " " + form.workStartTime, "MMDDYY HHmm").format('YYYY-MM-DDTHH:mm:ss.SS'),
                "workStartDay": form.workStartDay,
                "version": form.formbVersion,
            }
        };

        //For Form B convert all comments to capital letters
        restriction.restrictionDetail.comments.forEach(function (comm) {
            comm.comment = comm.comment.toUpperCase()
        });

        $.extend(restriction.restrictionDetail, formb);
    }
    else if (form.type === TYPES.C) {
        //Handle Multi Sub
        if (form.subdivisions && form.subdivisions.length === 1) {
            restriction.restrictionDetail.subdivision = form.subdivisions[0];
            restriction.restrictionDetail.restrictionSubdivisionList = [];
            restriction.restrictionDetail.restrictionSubdivisionList.push({ subdivisionName: form.subdivisions[0], sequenceNumber: 1 });
        }
        else {
            restriction.restrictionDetail.subdivision = "MULTI";
            restriction.restrictionDetail.subdivisions = form.subdivisions.map(function (sub, i) {
                return { subdivisionName: sub, sequenceNumber: i + 1 }
            })
            restriction.restrictionDetail.restrictionSubdivisionList = form.subdivisions.map(function (sub, i) {
                return { subdivisionName: sub, sequenceNumber: i + 1 }
            })
        }

        //MP can't be null, so set them to -1 if they don't have values
        if (restriction.restrictionDetail.workStartMp === "")
            restriction.restrictionDetail.workStartMp = -1;
        if (restriction.restrictionDetail.workEndMp === "")
            restriction.restrictionDetail.workEndMp = -1;

        let formc = {
            //form c fields
            "formCDetail": {
                "fromLocation": form.fromLocation,
                "toLocation": form.toLocation,
                "authorizedBy": form.authorizedBy,
                "estimatedRemovalDate": moment(form.estimatedRemovalDate + " 2359", "MMDDYYHHmm").tz(Constants.Timezones[form.timezone], true).format("YYYY-MM-DDTHH:mm:ss.SS"),
                "restrictionUpdateComments": form.formCDTChangeComment,
                "version": form.formcVersion,
            }
        };

        //For Form C convert all comments to capital letters
        restriction.restrictionDetail.comments.forEach(function (comm) {
            comm.comment = comm.comment.toUpperCase()
        });
        $.extend(restriction.restrictionDetail, formc);
    }

    else if (form.type === TYPES.TCM) {
        //MP can't be null, so set them to -1 if they don't have values
        if (restriction.restrictionDetail.workStartMp === "")
            restriction.restrictionDetail.workStartMp = -1;
        if (restriction.restrictionDetail.workEndMp === "")
            restriction.restrictionDetail.workEndMp = -1;

        let tcm = {
            //form tcm fields
            "tcmDetail": {
                "fromLocation": form.fromLocation,
                "toLocation": form.toLocation,
                "authorizedBy": form.authorizedBy,
                "estimatedRemovalDate": moment(form.estimatedRemovalDate + " 2359", "MMDDYYHHmm").tz(Constants.Timezones[form.timezone], true).format("YYYY-MM-DDTHH:mm:ss.SS"),
                "restrictionUpdateComments": form.formTCMDTChangeComment,
                "permanentIndicator": form.permanentIndicator,
                "printIndicator": form.printIndicator,
                "version": form.formTcmVersion,
            }
        };

        //For TCM convert all comments to capital letters
        restriction.restrictionDetail.comments.forEach(function (comm) {
            comm.comment = comm.comment.toUpperCase()
        });
        $.extend(restriction.restrictionDetail, tcm);
    }

    return restriction;
}

/**
 * Converts a form b from server format (object format) to server format (flat format)
 * scrubs the form b before returning it
 * @param restriction
 * @returns {*}
 */
function convertFormFromServerFormat(restriction) {
    if (restriction.restrictionDetail.borderingFlags) {
        restriction.restrictionDetail.borderingFlags.sort(function (a, b) {
            return a.id - b.id;
        });
    }
    try {
        var _form = {
            //request fields
            "requestId": restriction.id,
            "version": restriction.version,
            "gritVersion": restriction.gritVersion,
            "phoneNumber": restriction.phoneNumber,
            "pendingAction": restriction.pendingAction,
            "status": restriction.status,
            "supervisorName": restriction.supervisorName,
            "rejectionReason": restriction.rejectionReason,
            "dispatcherId": restriction.dispatcherId,
            "syncId": restriction.syncId,
            "isPushedFromTss": restriction.lastModifiedUser === "TSS_Push",
            "isOverrideItem": !(restriction.override == null),
            "warningNumber": restriction.warningNumber,

            //restriction fields
            "id": restriction.restrictionDetail.id,
            "effectiveTimeStamp": restriction.restrictionDetail.effectiveTimeStamp,
            "workEndMp": restriction.restrictionDetail.workEndMp === -1 ? "" : restriction.restrictionDetail.workEndMp,
            "workEndMpSuffix": formValidation.stringIsNullOrEmpty(restriction.restrictionDetail.workEndMpSuffix) ? "" : restriction.restrictionDetail.workEndMpSuffix,
            "workStartMp": restriction.restrictionDetail.workStartMp === -1 ? "" : restriction.restrictionDetail.workStartMp,
            "workStartMpSuffix": formValidation.stringIsNullOrEmpty(restriction.restrictionDetail.workStartMpSuffix) ? "" : restriction.restrictionDetail.workStartMpSuffix,
            "subdivision": restriction.restrictionDetail.subdivision,
            "type": restriction.restrictionDetail.type,
            "authInitials": restriction.restrictionDetail.authInitials,
            "tssId": restriction.restrictionDetail.controlNumber,//deprecated, left for backwards compatability
            "controlNumber": restriction.restrictionDetail.controlNumber,
            "restrictionVersion": restriction.restrictionDetail.version,
            "timeTableDirection": restriction.restrictionDetail.tmTblDirection,
            "timezone": restriction.restrictionDetail.timezone,

            //shortflag fields
            "shortFlagOneMp": restriction.restrictionDetail.shortFlag ? restriction.restrictionDetail.shortFlag.flagOneMp : null,
            "shortFlagOneMpSuffix": restriction.restrictionDetail.shortFlag ? restriction.restrictionDetail.shortFlag.flagOneMpSuffix : null,
            "shortFlagTwoMp": restriction.restrictionDetail.shortFlag ? restriction.restrictionDetail.shortFlag.flagTwoMp : null,
            "shortFlagTwoMpSuffix": restriction.restrictionDetail.shortFlag ? restriction.restrictionDetail.shortFlag.flagTwoMpSuffix : null,
            "shortFlagVersion": restriction.restrictionDetail.shortFlag ? restriction.restrictionDetail.shortFlag.version : null,
            "shortFlagsNotDisplayed": restriction.restrictionDetail.shortFlag ? restriction.restrictionDetail.shortFlag.restrictionFlagsNotDisplayed === "Y" : "",
            //track fields
            "tracks": restriction.restrictionDetail.tracks == null ? null : restriction.restrictionDetail.tracks.map(function (track) {
                return { name: track.name, checked: true, trackVersion: track.version }
            }),

            //bordering flag fields
            "borderingFlags": restriction.restrictionDetail.borderingFlags == null ? null : restriction.restrictionDetail.borderingFlags.map(function (flag) {
                //Add the ".0" if it is a round number
                let sanitizedMp = "" + flag.mp;
                if (sanitizedMp.indexOf(".") === -1) {
                    flag.mp += ".0";
                }
                return { mp: flag.mp, mpSuffix: flag.mpSuffix, subdivision: flag.subdivision, version: flag.version }
            }),

            //comments
            "comments": restriction.restrictionDetail.comments == null ? null : restriction.restrictionDetail.comments.map(function (com) {
                return { comment: com.comment, lineNumber: com.lineNumber, version: com.version }
            }),

            //dispatcher fields
            "dispatchers": restriction.dispatchers == null ? "[]" : restriction.dispatchers.map(function (owner) {
                return {
                    status: owner.statusCode,
                    dsid: owner.dispatcherId
                }
            }),

            "trackGuids": convertGuidToSchematicFormat(restriction.restrictionDetail.trackGuids.filter(function (g) {
                return g.isExcluded === false
            })),
            "excludedGuids": convertGuidToSchematicFormat(restriction.restrictionDetail.trackGuids.filter(function (g) {
                return g.isExcluded === true
            }))
        };

        if (_form.type.trim() === TYPES.A) {
            var forma = {
                //form a fields
                "passengerSpeed": restriction.restrictionDetail.formADetail.passengerSpeed > 0 ? restriction.restrictionDetail.formADetail.passengerSpeed : 'NA',
                "freightSpeed": restriction.restrictionDetail.formADetail.freightSpeed > 0 ? restriction.restrictionDetail.formADetail.freightSpeed : 'NA',
                "effectiveDate": restriction.restrictionDetail.formADetail.effectiveTime ? moment(restriction.restrictionDetail.formADetail.effectiveTime).format('MMDDYY') : "",
                "effectiveTime": restriction.restrictionDetail.formADetail.effectiveTime ? moment(restriction.restrictionDetail.formADetail.effectiveTime).format('HHmm') : "",
                "effectiveDatePrevious": restriction.restrictionDetail.formADetail.effectiveTime ? moment(restriction.restrictionDetail.formADetail.effectiveTime).format('MMDDYY') : "",
                "effectiveTimePrevious": restriction.restrictionDetail.formADetail.effectiveTime ? moment(restriction.restrictionDetail.formADetail.effectiveTime).format('HHmm') : "",
                "expectedExpireDate": moment(restriction.restrictionDetail.formADetail.expectedExpireTime).format('MMDDYY'),
                "reason": restriction.restrictionDetail.formADetail.reason.id,
                "reasonDescription": restriction.restrictionDetail.formADetail.reason.reasonDescription,
                //"expectedExpireTime": moment(request.restriction.formADetail.expectedExpireTime).format('HHmm'),
                "timezone": restriction.restrictionDetail.formADetail.effectiveTimezone,
                "authorizedBy": restriction.restrictionDetail.formADetail.authorizedBy,
                "sloDtComment": restriction.restrictionDetail.formADetail.sloDtChangeReason,
                "formaVersion": restriction.restrictionDetail.formADetail.version,
                "appliesToLimitedNumberOfTrains": restriction.restrictionDetail.formADetail.appliesToLimitedNumberOfTrains,
                "outForExtendedTime": restriction.restrictionDetail.formADetail.outForExtendedTime,
                "tmdsTagsPlaced": restriction.restrictionDetail.formADetail.tmdsTagsPlaced
            };

            _form = $.extend(_form, forma);

            //_form.request.restriction.shortFlagsNotDisplayed = request.restriction.shortFlag.restrictionFlagsNotDisplayed == "Y";
        }
        else if (_form && _form.type.trim() === TYPES.B) {
            var formb = {
                //form b fields
                "foremanId": restriction.restrictionDetail.formBDetail.foremanId,
                "foremanName": restriction.restrictionDetail.formBDetail.foremanName != null ? restriction.restrictionDetail.formBDetail.foremanName.trim() : "",
                "gang": restriction.restrictionDetail.formBDetail.gang != null ? restriction.restrictionDetail.formBDetail.gang.trim() : "",
                "impedesTraffic": restriction.restrictionDetail.formBDetail.impedesTraffic,
                "reason": restriction.restrictionDetail.formBDetail.reason.id,
                "reasonDescription": restriction.restrictionDetail.formBDetail.reason.reasonDescription,
                "radioChannel": restriction.restrictionDetail.formBDetail.radioChannel,
                "timezone": restriction.restrictionDetail.formBDetail.timezone,
                "workEndDate": moment(restriction.restrictionDetail.formBDetail.workEndDate).format('MMDDYY'),
                "workEndTime": moment(restriction.restrictionDetail.formBDetail.workEndDate).format('HHmm'),
                "workEndDay": restriction.restrictionDetail.formBDetail.workEndDay,
                "workStartDate": moment(restriction.restrictionDetail.formBDetail.workStartDate).format('MMDDYY'),
                "workStartTime": moment(restriction.restrictionDetail.formBDetail.workStartDate).format('HHmm'),
                "workStartDay": restriction.restrictionDetail.formBDetail.workStartDay,
                "formbVersion": restriction.restrictionDetail.formBDetail.version,
            };

            _form = $.extend(_form, formb);
            _form = formbScrubber.scrub(_form);
        }
        else if (_form && _form.type.trim() === TYPES.C) {
            let formc = {
                //form c fields
                "subdivisions": restriction.restrictionDetail.subdivisions.length > 0 ? restriction.restrictionDetail.subdivisions.map(function (sub) {
                    return sub.subdivisionName
                }) : [restriction.restrictionDetail.subdivision],
                "restrictionSubdivisionList": restriction.restrictionDetail.subdivisions.length > 0 ? restriction.restrictionDetail.subdivisions.map(function (sub) {
                    return sub.subdivisionName
                }) : [restriction.restrictionDetail.subdivision],
                "fromLocation": restriction.restrictionDetail.formCDetail.fromLocation != null ? restriction.restrictionDetail.formCDetail.fromLocation.trim() : "",
                "toLocation": restriction.restrictionDetail.formCDetail.toLocation != null ? restriction.restrictionDetail.formCDetail.toLocation.trim() : "",
                "authorizedBy": restriction.restrictionDetail.formCDetail.authorizedBy != null ? restriction.restrictionDetail.formCDetail.authorizedBy.trim() : "",
                "estimatedRemovalDate": moment(restriction.restrictionDetail.formCDetail.estimatedRemovalDate).format('MMDDYY'),
                "formCDTChangeComment": restriction.restrictionDetail.formCDetail.restrictionUpdateComments,
                "formcVersion": restriction.restrictionDetail.formCDetail.version,
            };

            _form = $.extend(_form, formc);
            _form = formbScrubber.scrub(_form);
        }

        else if (_form && _form.type.trim() === TYPES.TCM) {
            let tcm = {
                //tcm fields
                "fromLocation": restriction.restrictionDetail.tcmDetail.fromLocation != null ? restriction.restrictionDetail.tcmDetail.fromLocation.trim() : "",
                "toLocation": restriction.restrictionDetail.tcmDetail.toLocation != null ? restriction.restrictionDetail.tcmDetail.toLocation.trim() : "",
                "authorizedBy": restriction.restrictionDetail.tcmDetail.authorizedBy != null ? restriction.restrictionDetail.tcmDetail.authorizedBy.trim() : "",
                "estimatedRemovalDate": moment(restriction.restrictionDetail.tcmDetail.estimatedRemovalDate).format('MMDDYY'),
                "formTCMDTChangeComment": restriction.restrictionDetail.tcmDetail.restrictionUpdateComments,
                "printIndicator": restriction.restrictionDetail.tcmDetail.printIndicator,
                "permanentIndicator": restriction.restrictionDetail.tcmDetail.permanentIndicator,
                "formTcmVersion": restriction.restrictionDetail.tcmDetail.version,
            };

            _form = $.extend(_form, tcm);
            _form = formbScrubber.scrub(_form);
        }
        return _form;
    }
    catch (e) {
        return null;
    }
}

function convertFormFromNewServerFormat(restriction) {
    if (restriction.restrictionDetail.borderingFlags) {
        restriction.restrictionDetail.borderingFlags.sort(function (a, b) {
            return a.id - b.id;
        });
    }
    try {
        var _form = {
            //request fields
            "requestId": restriction.id,
            "version": restriction.version,
            "gritVersion": restriction.gritVersion,
            "phoneNumber": restriction.phoneNumber,
            "pendingAction": restriction.pendingAction,
            "status": restriction.status,
            "supervisorName": restriction.supervisorName,
            "rejectionReason": restriction.rejectionReason,
            "syncId": restriction.syncId,
            "isPushedFromTss": restriction.lastModifiedUser === "TSS_Push",
            "isOverrideItem": !(restriction.override == null),
            "createUser": restriction.createUser,
            "createTimeStamp": restriction.createTimeStamp,
            "warningNumber": restriction.warningNumber,
            "dispatcherId": restriction.dispatcherId,

            //restriction fields
            "id": restriction.restrictionDetail.id,
            "effectiveTimeStamp": restriction.restrictionDetail.effectiveTimeStamp,
            "workEndMp": restriction.restrictionDetail.workEndMp === -1 ? "" : restriction.restrictionDetail.workEndMp,
            "workEndMpSuffix": formValidation.stringIsNullOrEmpty(restriction.restrictionDetail.workEndMpSuffix) ? "" : restriction.restrictionDetail.workEndMpSuffix,
            "workStartMp": restriction.restrictionDetail.workStartMp === -1 ? "" : restriction.restrictionDetail.workStartMp,
            "workStartMpSuffix": formValidation.stringIsNullOrEmpty(restriction.restrictionDetail.workStartMpSuffix) ? "" : restriction.restrictionDetail.workStartMpSuffix,
            "subdivision": restriction.restrictionDetail.subdivision,
            "type": restriction.restrictionDetail.type,
            "authInitials": restriction.restrictionDetail.authInitials,
            "tssId": restriction.restrictionDetail.controlNumber,//deprecated, left for backwards compatability
            "controlNumber": restriction.restrictionDetail.controlNumber,
            "restrictionVersion": restriction.restrictionDetail.version,
            "timeTableDirection": restriction.restrictionDetail.tmTblDirection,
            "timezone": restriction.restrictionDetail.timezone,

            //shortflag fields
            "shortFlagOneMp": restriction.restrictionDetail.shortFlag ? restriction.restrictionDetail.shortFlag.flagOneMp !== null ? restriction.restrictionDetail.shortFlag.flagOneMp: "" : "",
            "shortFlagOneMpSuffix": restriction.restrictionDetail.shortFlag ? restriction.restrictionDetail.shortFlag.flagOneMpSuffix !== null ? restriction.restrictionDetail.shortFlag.flagOneMpSuffix.trim() : "" : "",
            "shortFlagTwoMp": restriction.restrictionDetail.shortFlag ? restriction.restrictionDetail.shortFlag.flagTwoMp !== null ? restriction.restrictionDetail.shortFlag.flagTwoMp : "" : "",
            "shortFlagTwoMpSuffix": restriction.restrictionDetail.shortFlag ? restriction.restrictionDetail.shortFlag.flagTwoMpSuffix !== null ? restriction.restrictionDetail.shortFlag.flagTwoMpSuffix.trim() : "" : "",
            "shortFlagVersion": restriction.restrictionDetail.shortFlag ? restriction.restrictionDetail.shortFlag.version : "",
            "shortFlagsNotDisplayed": restriction.restrictionDetail.shortFlag ? restriction.restrictionDetail.shortFlag.restrictionFlagsNotDisplayed === "Y" : "",
            //track fields
            "tracks": restriction.restrictionDetail.tracks == null ? [] : restriction.restrictionDetail.tracks.map(function (track) {
                return { name: track.name, checked: true, trackVersion: track.version }
            }),

            //bordering flag fields
            "borderingFlags": restriction.restrictionDetail.borderingFlags == null ? [] : restriction.restrictionDetail.borderingFlags.map(function (flag) {
                //Add the ".0" if it is a round number
                let sanitizedMp = "" + flag.mp;
                if (sanitizedMp.indexOf(".") === -1) {
                    flag.mp += ".0";
                }
                return { mp: flag.mp, mpSuffix: flag.mpSuffix, subdivision: flag.subdivision, version: flag.version }
            }),

            //comments
            "comments": restriction.restrictionDetail.comments == null ? [] : restriction.restrictionDetail.comments.map(function (com) {
                return { comment: com.comment, lineNumber: com.lineNumber, version: com.version }
            }),

            //dispatcher fields
            "dispatchers": restriction.dispatchers == null ? [] : restriction.dispatchers.map(function (owner) {
                return {
                    status: owner.statusCode,
                    dsid: owner.dispatcherId
                }
            }),


        };

        if (_form.type.trim() === TYPES.A) {
            var forma = {
                //form a fields
                "passengerSpeed": restriction.restrictionDetail.formADetail.passengerSpeed > 0 ? restriction.restrictionDetail.formADetail.passengerSpeed : 'NA',
                "freightSpeed": restriction.restrictionDetail.formADetail.freightSpeed > 0 ? restriction.restrictionDetail.formADetail.freightSpeed : 'NA',
                "effectiveDate": restriction.restrictionDetail.formADetail.effectiveTime ? moment(restriction.restrictionDetail.formADetail.effectiveTime).format('MMDDYY') : "",
                "effectiveTime": restriction.restrictionDetail.formADetail.effectiveTime ? moment(restriction.restrictionDetail.formADetail.effectiveTime).format('HHmm') : "",
                "effectiveDatePrevious": restriction.restrictionDetail.formADetail.effectiveTime ? moment(restriction.restrictionDetail.formADetail.effectiveTime).format('MMDDYY') : "",
                "effectiveTimePrevious": restriction.restrictionDetail.formADetail.effectiveTime ? moment(restriction.restrictionDetail.formADetail.effectiveTime).format('HHmm') : "",
                "expectedExpireDate": moment(restriction.restrictionDetail.formADetail.expectedExpireTime).format('MMDDYY'),
                "reason": restriction.restrictionDetail.formADetail.reasonCode.gritReasonId,
                "reasonDescription": restriction.restrictionDetail.formADetail.reasonCode.reasonDescription,
                //"expectedExpireTime": moment(request.restriction.formADetail.expectedExpireTime).format('HHmm'),
                "timezone": restriction.restrictionDetail.formADetail.effectiveTimezone,
                "authorizedBy": restriction.restrictionDetail.formADetail.authorizedBy,
                "sloDtComment": restriction.restrictionDetail.formADetail.sloDtChangeReason,
                "formaVersion": restriction.restrictionDetail.formADetail.version,
                "appliesToLimitedNumberOfTrains": restriction.restrictionDetail.formADetail.appliesToLimitedNumberOfTrains,
                "outForExtendedTime": restriction.restrictionDetail.formADetail.outForExtendedTime,
                "tmdsTagsPlaced": restriction.restrictionDetail.formADetail.tmdsTagsPlaced,

                "trackGuids": convertGuidToSchematicFormat(restriction.restrictionDetail.trackGuids.filter(function (g) {
                    return g.isExcluded === false
                })),
                "excludedGuids": convertGuidToSchematicFormat(restriction.restrictionDetail.trackGuids.filter(function (g) {
                    return g.isExcluded === true
                }))
            };

            _form = $.extend(_form, forma);

            //_form.request.restriction.shortFlagsNotDisplayed = request.restriction.shortFlag.restrictionFlagsNotDisplayed == "Y";
        }
        else if (_form && _form.type.trim() === TYPES.B) {
            var formb = {
                //form b fields
                "foremanId": restriction.restrictionDetail.formBDetail.foremanId,
                "foremanName": restriction.restrictionDetail.formBDetail.foremanName != null ? restriction.restrictionDetail.formBDetail.foremanName.trim() : "",
                "gang": restriction.restrictionDetail.formBDetail.gang != null ? restriction.restrictionDetail.formBDetail.gang.trim() : "",
                "impedesTraffic": restriction.restrictionDetail.formBDetail.impedesTraffic,
                "reason": restriction.restrictionDetail.formBDetail.reasonCode.gritReasonId,
                "reasonDescription": restriction.restrictionDetail.formBDetail.reasonCode.reasonDescription,
                "radioChannel": restriction.restrictionDetail.formBDetail.radioChannel,
                "timezone": restriction.restrictionDetail.formBDetail.timezone,
                "workEndDate": moment(restriction.restrictionDetail.formBDetail.workEndDate).format('MMDDYY'),
                "workEndTime": moment(restriction.restrictionDetail.formBDetail.workEndDate).format('HHmm'),
                "workEndDay": restriction.restrictionDetail.formBDetail.workEndDay,
                "workStartDate": moment(restriction.restrictionDetail.formBDetail.workStartDate).format('MMDDYY'),
                "workStartTime": moment(restriction.restrictionDetail.formBDetail.workStartDate).format('HHmm'),
                "workStartDay": restriction.restrictionDetail.formBDetail.workStartDay,
                "formbVersion": restriction.restrictionDetail.formBDetail.version,

                "trackGuids": convertGuidToSchematicFormat(restriction.restrictionDetail.trackGuids.filter(function (g) {
                    return g.isExcluded === false
                })),
                "excludedGuids": convertGuidToSchematicFormat(restriction.restrictionDetail.trackGuids.filter(function (g) {
                    return g.isExcluded === true
                }))
            };

            _form = $.extend(_form, formb);
            _form = formbScrubber.scrub(_form);
        }
        else if (_form && _form.type.trim() === TYPES.C) {
            let formc = {
                //form c fields
                "subdivisions": restriction.restrictionDetail.restrictionSubdivisionList !==null && restriction.restrictionDetail.restrictionSubdivisionList.length > 0 ? restriction.restrictionDetail.restrictionSubdivisionList.map(function (sub) {
                    return sub.subdivisionName
                }) : [restriction.restrictionDetail.subdivision],
                "restrictionSubdivisionList": restriction.restrictionDetail.restrictionSubdivisionList !==null && restriction.restrictionDetail.restrictionSubdivisionList.length > 0 ? restriction.restrictionDetail.restrictionSubdivisionList.map(function (sub) {
                    return sub.subdivisionName
                }) : [restriction.restrictionDetail.subdivision],
                "fromLocation": restriction.restrictionDetail.formCDetail.fromLocation != null ? restriction.restrictionDetail.formCDetail.fromLocation.trim() : "",
                "toLocation": restriction.restrictionDetail.formCDetail.toLocation != null ? restriction.restrictionDetail.formCDetail.toLocation.trim() : "",
                "authorizedBy": restriction.restrictionDetail.formCDetail.authorizedBy != null ? restriction.restrictionDetail.formCDetail.authorizedBy.trim() : "",
                "estimatedRemovalDate": moment(restriction.restrictionDetail.formCDetail.estimatedRemovalDate).tz(Constants.Timezones[restriction.restrictionDetail.timezone]).format('MMDDYY'),
                "formCDTChangeComment": restriction.restrictionDetail.formCDetail.restrictionUpdateComments,
                "formcVersion": restriction.restrictionDetail.formCDetail.version,
                "trackGuids": [],
                "excludedGuids": []
            };

            _form = $.extend(_form, formc);
            _form = formbScrubber.scrub(_form);
        }

        else if (_form && _form.type.trim() === TYPES.TCM) {
            let tcm = {
                //tcm fields
                "fromLocation": restriction.restrictionDetail.tcmDetail.fromLocation != null ? restriction.restrictionDetail.tcmDetail.fromLocation.trim() : "",
                "toLocation": restriction.restrictionDetail.tcmDetail.toLocation != null ? restriction.restrictionDetail.tcmDetail.toLocation.trim() : "",
                "authorizedBy": restriction.restrictionDetail.tcmDetail.authorizedBy != null ? restriction.restrictionDetail.tcmDetail.authorizedBy.trim() : "",
                "estimatedRemovalDate": moment(restriction.restrictionDetail.tcmDetail.estimatedRemovalDate).tz(Constants.Timezones[restriction.restrictionDetail.timezone]).format('MMDDYY'),
                "formTCMDTChangeComment": restriction.restrictionDetail.tcmDetail.restrictionUpdateComments,
                "printIndicator": restriction.restrictionDetail.tcmDetail.printIndicator,
                "permanentIndicator": restriction.restrictionDetail.tcmDetail.permanentIndicator,
                "formTcmVersion": restriction.restrictionDetail.tcmDetail.version,
                "trackGuids": [],
                "excludedGuids": []
            };

            _form = $.extend(_form, tcm);
            _form = formbScrubber.scrub(_form);
        }
        return _form;
    }
    catch (e) {
        console.error("unable to convert to server format", e)
        return null;
    }
}

/**
 * clones a form using JSON stringify
 * @param oldObj
 */
function clone(oldObj) {
    return JSON.parse(JSON.stringify(oldObj))
}

function convertSubDetailsToSchematicFormat(details) {
    var schMpRng = [], j = 0, l;

    //Added a check for details milePostRangelist is defined. At times it is undefined
    if (details.milePostRangeList) {
        l = details.milePostRangeList.length;
    }
    else {
        l = 0;
    }

    if (['S', 'W'].indexOf(details.defaultDirection) > -1) {
        //if the sub runs south or west we need to reverse the mp range table from the MF
        for (var i = l - 1; i > -1; i--) {
            var range = details.milePostRangeList[i];
            schMpRng[j] = { from: '', to: '', sfx: '' };
            schMpRng[j].from = range.to;
            schMpRng[j].to = range.from;
            schMpRng[j].sfx = range.fromSuffix;
            schMpRng[j].seqLow = range.sequenceHigh;
            schMpRng[j].seqHigh = range.sequenceLow;
            schMpRng[j].sequence = j;
            j++;
        }
    }
    else {
        //otherwise we can leave the mp range table as is and just transform it
        for (var i = 0; i > l; i++) {
            var range = details.milePostRangeList[i];
            schMpRng[i] = { from: '', to: '', sfx: '' };
            schMpRng[i].from = range.from;
            schMpRng[i].to = range.to;
            schMpRng[i].sfx = range.fromSuffix;
            schMpRng[j].seqLow = range.sequenceLow;
            schMpRng[j].seqHigh = range.sequenceHigh;
            schMpRng[i].sequence = i;
        }
    }

    details.milePostRangeList = schMpRng;

    return details;
}

function convertGuidToServerFormat(guids, areExcluded) {
    return guids.map(function (g) {
        return {
            "guidNumber": g[TrackFields.TRACK_GUID],
            "startMp": g[TrackFields.TRACK_BMP],
            "endMp": g[TrackFields.TRACK_EMP],
            "mpSuffix": g[TrackFields.TRACK_MPSUF],
            "dbVersion": g["databaseVersion"],
            "ptcVersion": g["versionPtcReference"],
            "trackName": g[TrackFields.TRACK_NAME],
            "subdivision": g[TrackFields.TRACK_SUBDIV],
            "isExcluded": areExcluded
        }
    })
}


function convertGuidToSchematicFormat(guids) {
    return guids.map(function (g) {
        var obj = {};
        obj[TrackFields.TRACK_GUID] = g["guidNumber"];
        obj[TrackFields.TRACK_BMP] = g["startMp"];
        obj[TrackFields.TRACK_EMP] = g["endMp"];
        obj[TrackFields.TRACK_MPSUF] = g["mpSuffix"];
        obj["databaseVersion"] = g["dbVersion"];
        obj["versionPtcReference"] = g["ptcVersion"];
        obj[TrackFields.TRACK_NAME] = g["trackName"];
        obj[TrackFields.TRACK_SUBDIV] = g["subdivision"];

        return obj;

    })
}

//from: http://stackoverflow.com/questions/4025893/how-to-check-identical-array-in-most-efficient-way
//thanks to http://stackoverflow.com/users/393280/palswim
function arraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length)
        return false;
    for (var i = arr1.length; i--;) {
        if (arr1[i] !== arr2[i])
            return false;
    }
    return true;
}


//public api
export const formConversion = {
    getClientFormat: convertFormFromServerFormat,
    getNewClientFormat: convertFormFromNewServerFormat,
    getServerFormat: convertFormToServerFormat,
    clone,
    convertSubDetailsToSchematicFormat,
    areArraysEqual: arraysEqual
};
